import * as React from "react";
import StoreContainer from "../../../stores/StoreContainer";
import * as Icons from "../../Icons";

interface SocialQuestionProps {
  question: any;
}

class SocialQuestion extends React.Component<SocialQuestionProps, {}> {
  renderButton = (choice: any) => {
    switch (choice.ChoiceText) {
      case "facebook":
        return this.renderFacebookButton();
      case "twitter":
        return this.renderTwitterButton();
      case "google":
        return this.renderGoogleButton();
      case "linkedin":
        return this.renderLinkedInButton();
      default:
        throw new Error(`unsupported social type: ${choice.ChoiceText}`);
    }
  };

  renderFacebookButton() {
    return (
      <button
        className="velaro-btn-social facebook"
        type="button"
        key="facebook"
        onClick={() => StoreContainer.OAuthStore.connectFacebook()}
      >
        <Icons.Facebook />
        Facebook
      </button>
    );
  }

  renderTwitterButton() {
    return (
      <button
        className="velaro-btn-social twitter"
        type="button"
        key="twitter"
        onClick={() => StoreContainer.OAuthStore.connectTwitter()}
      >
        <Icons.Twitter />
        Twitter
      </button>
    );
  }

  renderGoogleButton() {
    return (
      <button
        className="velaro-btn-social google"
        type="button"
        key="google"
        onClick={() => StoreContainer.OAuthStore.connectGoogle()}
      >
        <Icons.Google />
        Google
      </button>
    );
  }

  renderLinkedInButton() {
    return (
      <button
        className="velaro-btn-social linkedin"
        type="button"
        key="linkedin"
        onClick={() => StoreContainer.OAuthStore.connectLinkedIn()}
      >
        <Icons.LinkedIn />
        LinkedIn
      </button>
    );
  }

  isConnected() {
    return !!StoreContainer.OAuthStore.getSocialData();
  }

  render() {
    if (this.isConnected()) {
      return null;
    }

    return (
      <div>
        {this.props.question.SurveyQuestionChoices.map(this.renderButton)}
      </div>
    );
  }
}

export default SocialQuestion;
